import React, { Fragment } from 'react';
import { Paper } from '@material-ui/core';
import i18n from '../../i18n';
import styles from '../../assets/stylesheets/CallsheetInlineStyles';
import { AD_LABEL } from '../../constants/general';

export const generatePositionTableRow = (i18nPositionKey, positionInfo) => {
  return (
    <Fragment key={i18nPositionKey}>
      <tr>
        <th style={styles.tableCell} colSpan="4">
          {i18n.t(`booking:${i18nPositionKey}`)}
        </th>
      </tr>
      {positionInfo ? (
        <tr>
          <td style={styles.tableHead} colSpan="4">
            <ul style={styles.ul}>
              {positionInfo.employees.map(employee => (
                <li key={employee.name} style={styles.tableCell}>
                  {`${employee.name} ${employee.availabilityType === AD_LABEL ? '' : `[${employee.availabilityType}]`}`}
                </li>
              ))}
            </ul>
          </td>

        </tr>
      ) : (
        <tr>
          <td style={styles.tableCell} colSpan="4">
            {i18n.t('none')}
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export const generatePositions = (sheetData) => {
  return sheetData.requiredPositions
    .filter(pos => pos.enabled && (pos.gender === null || pos.gender === sheetData.gender))
    .map(pos =>{
      return generatePositionTableRow(pos.position.i18nLabel, sheetData.positions[pos.position.positionName])
    });
};

export const generateDoubleBooking = (sheetData) => {
  // because 'sort' is an in-place algorithm - we make a copy of the array before processing 
  const requiredPositionsCopy = sheetData.requiredPositions.slice();
  return requiredPositionsCopy
    .sort((a,b)=> a.group === b.group ? a.order-b.order : a.group-b.group)
    .filter(pos => pos.allowDoubleBooking && pos.enabled && (pos.gender === null || pos.gender === sheetData.gender))
    .map(pos =>{
      const isDoubleBooking = sheetData[pos.doubleBookingField];
      const label = i18n.exists(`booking:${pos.position.i18nLabel}Short`) ? i18n.t(`booking:${pos.position.i18nLabel}Short`) : i18n.t(`booking:${pos.position.i18nLabel}`);
      const val = isDoubleBooking ? 'Yes' : 'No'
      return (
        <div key={`${label}-${pos.gender}`}>
          {`${label}: ${val}`}
        </div>
      )
    });
};

export const renderSheets = (SheetType, locations, renderForEmail, locationContacts) =>
  Object.entries(locations).map(locationEntry => {
    const [locationName, locationData] = locationEntry;
    return renderForEmail ? (
      <SheetType
        key={`${locationData.callSheetOrder} ${locationName}`}
        name={locationName}
        info={locationData}
        locationContacts={locationContacts}
        renderForEmail
      />
    ) : (
      <Paper key={`${locationData.callSheetOrder} ${locationName}`} className="bookingForm">
        <SheetType
          name={locationName}
          info={locationData}
          locationContacts={locationContacts}
          renderForEmail={false}
        />
      </Paper>
    );
  });
